// src/modules/shared/enums/common-enum.tsx

declare const process: {
  env: {
    REACT_APP_API_HOST?: string;
    REACT_APP_API_KEY?: string;
    [key: string]: string | undefined;
  };
};

export const API_HOST = process.env.REACT_APP_API_HOST ?? "";
export const API_KEY = process.env.REACT_APP_API_KEY ?? "";
export const BASE_URL = `${API_HOST}/api/v2.0`;
export const AUTH_URL = `${BASE_URL}/auth`;
export const USER_URL = `${BASE_URL}/users`;
export const CAMPAIGN_URL = `${BASE_URL}/engagements/campaigns`;
export const REWARD_URL = `${BASE_URL}/engagements/rewards`;
export const DASHBOARD_URL = `${BASE_URL}/statistic`;
export const MEDIA_URL = `${BASE_URL}/media`;
export const POST_URL = `${BASE_URL}/social/posts`;

export const userPublicPostsUrl = (
  userId: string,
  page: number,
  limit: number,
) =>
  `${POST_URL}/users/${encodeURIComponent(userId)}/public?page=${page}&limit=${limit}`;
export const POLICY_URL = `${BASE_URL}/policy`;
export const NOTIFICATIONS_URL = `${BASE_URL}/notifications`;
export const REPORT_URL = `${BASE_URL}/generic/reports`;
export const FITCOINS_URL = `${BASE_URL}/fitcoins/wallets`;

export const API_URL = {
  AUTH_SIGN_IN: `${AUTH_URL}/sign-in/admin`,
  AUTH_SIGN_UP: `${AUTH_URL}/sign-up/admin`,
  AUTH_SIGN_OUT: `${AUTH_URL}/sign-out`,
  AUTH_REFRESH: `${AUTH_URL}/refresh`,
  USER: `${USER_URL}/me`,
  SEARCH_USERS: `${USER_URL}/search`,
  TRAINERS: `${USER_URL}/admin/trainers`,
  TOP_TRAINERS: `${USER_URL}/top-trainers`,
  UPDATE_TOP_TRAINERS: `${USER_URL}/admin/top-trainers`,
  PRIORITY_TOP_TRAINERS: `${USER_URL}/admin/top-trainers/reorder`,
  CLIENTS: `${USER_URL}/admin/clients`,
  SETTING: `${USER_URL}/settings`,
  GET_CAMPAGINS: `${API_HOST}/api/v2.0/engagements/campaigns`,
  CREATE_CAMPAIGNS: `${API_HOST}/api/v2.0/engagements/campaigns`,
  DELETE_CAMPAIGNS: `${API_HOST}/api/v2.0/engagements/campaigns`,
  UPDATE_CAMPAIGNS: `${API_HOST}/api/v2.0/engagements/campaigns`,
  GET_REWARDS: `${API_HOST}/api/v2.0/engagements/rewards`,
  GET_BULK_REWARDS: `${API_HOST}/api/v2.0/engagements/rewards/gets/bulk`,
  CREATE_REWARDS: `${API_HOST}/api/v2.0/engagements/rewards`,
  DELETE_REWARDS: `${API_HOST}/api/v2.0/engagements/rewards/`,
  MEDIA_URL: `${MEDIA_URL}`,
  POST_ADMIN: `${POST_URL}`,
  POLICY: `${POLICY_URL}`,
  AGE_GENDER_CHART_URL: `${DASHBOARD_URL}/age-gender`,
  COUNT_SUMMARY_CHART_URL: `${DASHBOARD_URL}/count/summary`,
  AGE_GENDER_SUMMARY_URL: `${DASHBOARD_URL}/age-gender/summary`,
  SIGNUP_SUMARRY: `${DASHBOARD_URL}/signup/summary`,
  GET_WALLET_OF_USER_ID: `${FITCOINS_URL}/user`,
  UPSERT_FCM_TOKEN: `${NOTIFICATIONS_URL}/upsert-fcm-token`,
  UNVERIFIED_TRAINER_PACKAGE: `${BASE_URL}/admin/trainer-packages`,
  TRAINER_PACKAGE_BY_ID: `${BASE_URL}/trainer-packages/user`,
  VERIFY_TRAINER: `${BASE_URL}/admin/users/verify`,
  VERIFY_PACKAGE: `${BASE_URL}/admin/trainer-packages/verify`,
  AI_ASSISTANT_STATUS: `${BASE_URL}/open-ai-assistants/assistant-status`,
  AI_ASSISTANT_ID: `${BASE_URL}/open-ai-assistants/assistant-id`,
  AI_VECTOR_STORAGE_ID: `${BASE_URL}/open-ai-assistants/vector-storage-id`,
  AI_ASSISTANT_UPDATE: `${BASE_URL}/open-ai-assistants/update-assistant`,
  AI_ASSISTANT_INITIAL: `${BASE_URL}/open-ai-assistants/initial-assistant`,
  REMOVE_DUPE_FOLLOW: `${BASE_URL}/social/follows/admin/remove-dupe`,
  SYNC_INDEXES_FOLLOW: `${BASE_URL}/social/follows/admin/sync-indexes`,
  REMOVE_DUPE_CONNECT: `${BASE_URL}/matches/admin/remove-dupe`,
  SYNC_INDEXES_CONNECT: `${BASE_URL}/matches/admin/sync-indexes`,
  REMOVE_DUPE_SOCIAL_REACTION: `${BASE_URL}/social/reactions/admin/remove-dupe`,
  SYNC_INDEXES_SOCIAL_REACTION: `${BASE_URL}/social/reactions/admin/sync-indexes`,
  REMOVE_DUPE_COMMUNITY_REACTION: `${BASE_URL}/community/reactions/admin/remove-dupe`,
  SYNC_INDEXES_COMMUNITY_REACTION: `${BASE_URL}/community/reactions/admin/sync-indexes`,
  FEATURE_FLAGS: `${BASE_URL}/feature-flags`,
  APP_VERSION_CONFIG: `${BASE_URL}/feature-flags/app-version/config`,
  WEEKLY_SCHEDULE: `${BASE_URL}/weekly-schedule-settings`,
  B2B: `${BASE_URL}/b2b`,
  MARKETPLACE_SHOP: `${BASE_URL}/marketplace/shop`,
  MARKETPLACE_ITEM: `${BASE_URL}/marketplace/item`,
  MARKETPLACE_ORDER: `${BASE_URL}/marketplace/order`,
  USER_BY_ID: `${USER_URL}`,
  B2B_BRANCH: `${BASE_URL}/b2b-branch`,
  B2B_BRANCH_SERVICE: `${BASE_URL}/b2b-branch/service`,
  B2B_BRANCH_SERVICES: (branchId: string) =>
    `${BASE_URL}/b2b-branch/${branchId}/service`,
} as const;

export const trainerSendToAcademyUrl = (trainerUserId: string) =>
  `${USER_URL}/trainer/${encodeURIComponent(trainerUserId)}/send-to-academy`;

export const forceVerifyTrainerUrl = (trainerUserId: string) =>
  `${USER_URL}/admin/trainer/${encodeURIComponent(trainerUserId)}/force-verify`;

export const searchUsersUrl = (keyword: string) =>
  `${USER_URL}/search?keyword=${encodeURIComponent(keyword.trim())}`;

// Header mặc định – sử dụng API_KEY đã export
export const API_HEADER: HeadersInit = {
  "x-platform": "desktop",
  "x-app-version": "0.0.1",
  "x-api-secret-key": API_KEY,
  "Content-Type": "application/json",
};

export enum Identifier {
  phone = "phone",
  email = "email",
  none = "none",
}
